<div [@routerTransition]>
    <div class="content d-flex flex-column flex-column-fluid">
        <sub-header></sub-header>

        <div [class]="containerClass">
            <div class="card card-custom gutter-b">
                <div class="card-body">
                  Coming Soon
                </div>
            </div>
        </div>
    </div>
</div>
